<script setup>
defineProps({
  page: {
    type: Object,
    required: true,
  },
})

const getItemKey = (item) => {
  if (typeof item === 'string') {
    return item
  }

  return `${item.label || ''}-${item.value || item.href}`
}

const isLinkItem = (item) => typeof item === 'object' && item.href
</script>

<template>
  <main class="legal-page">
    <section class="legal-page__hero">
      <a class="legal-page__brand" href="/#section-hero" aria-label="SmartWork">
        <span>Smart</span><span class="legal-page__brand-accent">W</span><span>ork</span>
      </a>
      <div class="legal-page__inner">
        <a class="legal-page__back" href="/#section-hero">
          <i class="fa-solid fa-arrow-left" aria-hidden="true"></i>
          <span>Retour à l’accueil</span>
        </a>
        <p class="legal-page__eyebrow">{{ page.eyebrow }}</p>
        <h1 class="legal-page__title">{{ page.title }}</h1>
        <p class="legal-page__intro">{{ page.intro }}</p>
        <p class="legal-page__updated">Dernière mise à jour : {{ page.updated }}</p>
      </div>
    </section>

    <section class="legal-page__body" aria-label="Contenu légal">
      <div class="legal-page__inner legal-page__content">
        <article v-for="section in page.sections" :key="section.title" class="legal-page__section">
          <h2 class="legal-page__section-title">{{ section.title }}</h2>
          <p v-for="paragraph in section.paragraphs" :key="paragraph" class="legal-page__paragraph">
            {{ paragraph }}
          </p>
          <ul v-if="section.items?.length" class="legal-page__list">
            <li v-for="item in section.items" :key="getItemKey(item)">
              <template v-if="isLinkItem(item)">
                <span v-if="item.label">{{ item.label }} : </span>
                <a :href="item.href" :target="item.external === false ? undefined : '_blank'"
                  :rel="item.external === false ? undefined : 'noopener noreferrer'">
                  {{ item.value || item.href }}
                </a>
              </template>
              <template v-else>{{ item }}</template>
            </li>
          </ul>
        </article>
      </div>
    </section>
  </main>
</template>
